<template lang="pug">
  .top-menu(:style="{ height: navHeight + 'px'}")
    nav.bg-gray-light(ref="container" :class="{ fixed: navFixed, up: navHidden }")
      ul(ref="bar").xs-f-xsmall.lg-f-small.max-at-tweak
        li(v-for="(item, index) in navItems")
          a.color-black(v-if="item.out" :href="item.url" :data-mr-ass="item.text" :class="{ 'semi-bold': index == activeIndex }" ) {{ item.text }}
          router-link.color-black(v-else exact :to="item.url" :key="index" ref="button" :class="{ 'semi-bold': index == activeIndex }" :data-mr-ass="item.text") {{ item.text }}
      .slider-bar-container(ref="sliderContainer")
        span.slider(ref="slider" :class="{ ninja: sliderHidden }")

</template>

<script>
  export default {
    name: "TopMenu",

    props: {
      navItems: {
        type: Array,
        default: []
      }
    },

    data() {
      return {
        isMounted: false,
        isOverflowing: false,
        scrolling: false,
        midPoint: 0,
        targetLocation: 0,
        targetWidth: 0,
        containerLeft: 0,
        resizeTimeout: 0,
        widths: {
          bar: 0,
          scroll: 0
        }
      }
    },

    inject: ['getObjProperty'],

    computed: {
      activeIndex() {
        var activeUrl = '';
        var active = 0;
        if (this.isMounted) {
          this.navItems.forEach((item, index) => {
            if (this.$route.path.includes(item.url) && item.url.length > activeUrl.length) {
              activeUrl = item.url;
              active = index;
              var activeTab = this.$refs.bar.children[active];
              this.targetWidth = activeTab.getBoundingClientRect().width;
              this.targetLocation = activeTab.getBoundingClientRect().x;
              this.containerLeft = this.$refs.container.getBoundingClientRect().x;
              this.barLeft = this.$refs.bar.getBoundingClientRect().x;
              this.$refs.slider.style.width = `${this.targetWidth}px`;
              this.scrollInToView();
            }
          });
        }

        return active;
      },

      navHeight() {
        if (this.isMounted) {
          return Math.ceil($(this.$refs.container).outerHeight());
        }
      },

      wrapperTop() {
        if (this.isMounted) {
          return $(this.$el).offset().top;
        }
      },

      wrapperBottom() {
        if (this.isMounted) {
          return this.wrapperTop + this.navHeight;
        }
      },

      navFixed() {
        if (this.isMounted && this.$root.windowData.scrollTop > this.wrapperTop) {
          return true;
        } else {
          return false;
        }
      },

      navHidden() {
        if (this.navFixed && this.$root.windowData.scrollTop > this.wrapperBottom + 15 && this.$root.windowData.scrollDirection == 1) {
          return true;
        } else {
          return false;
        }
      },

      sliderHidden() {
        return this.activeIndex == 0 && !this.$route.path.includes(this.navItems[0].url);
      }
    },

    destroyed() {
      window.removeEventListener("resize", this.setWidths);
    },

    mounted() {
      this.isMounted = true;

      window.addEventListener("resize", () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(this.initActiveNavItem, 200);
      });

      this.$nextTick(function() {
        this.initActiveNavItem();
      });
    },

    methods: {
      initActiveNavItem() {
        this.setWidths();
      },

      setWidths() {
        if (!this.getObjProperty(this, '$refs.bar')) {
          return;
        }

        const bar = this.$refs.bar.clientWidth || 0;
        const scroll = this.$refs.bar.scrollWidth || 0;

        this.widths = { bar, scroll };
        this.midPoint = bar / 2;
        this.$refs.sliderContainer.style.width = `${this.widths.scroll}px`;

        this.setOverflow();
      },

      setOverflow() {
        this.isOverflowing = this.widths.bar < this.widths.scroll;
      },

      scrollInToView() {
        let halfTarget = this.targetWidth / 2;
        let offset = (this.targetLocation - this.midPoint) + halfTarget ;
        var counter = 0;
        var steps = 40;
        var sliderLeft = 0;

        if (this.barLeft > 0) {
          sliderLeft = `${this.targetLocation - Math.abs(this.barLeft)}px`;
        } else {
          sliderLeft = `${this.targetLocation + Math.abs(this.barLeft)}px`;
        }

        this.$refs.slider.style.left = sliderLeft;

        if (!this.isOverflowing) {
          return;
        }

        offset = offset / steps;
        var sI = setInterval(() => {
          this.$refs.container.scrollLeft += offset;
          counter++;
          if (counter > steps)
            clearInterval(sI);
        }, 10);
      }
    }
  }
</script>

<style scoped lang="stylus">

</style>
